import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";

export const useGetErrorLogData = ({body, config}) => {
    return useQuery({
      queryKey: [QUERY_KEYS.ERRORLOG,body.fileDate],
      queryFn: () => {
        return axios
          .get(`${process.env.REACT_APP_API_URI}ErrorLogs?fileDate=${body.fileDate}&fromDate=${body.fromDate}&toDate=${body.toDate}&key=${body.key}`, config)
          .then((res) => {
            if(res.data.error){
              throw new Error(res.data.message)
            }
            return res.data;
          });
      },
      refetchOnWindowFocus: false,
    });
  }